//jacques-andre-editeur\proshop-v2\frontend\src\screens\AuthorScreen.jsx
import { useParams } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import DOMPurify from 'dompurify';
import { useGetAuthorDetailsQuery} from '../slices/authorsApiSlice';
import { useGetBooksByAuthorQuery, useGetBooksByTranslatorQuery } from '../slices/booksApiSlice';
import Loader from '../components/Loader';
import Message from '../components/Message';
import { FaWikipediaW, FaYoutube, FaFacebook, FaInstagram, FaLinkedin, FaXTwitter, FaThreads, FaMastodon } from "react-icons/fa6";
//import { FaWikipediaW, FaFacebook, FaInstagram, FaLinkedin, FaXTwitter, FaBluesky, FaThreads, FaMastodon } from "react-icons/fa6";
import BookCard from '../components/BookCard';

const AuthorScreen = () => {
  const { slug } = useParams();
  const { data: author, isLoading, error } = useGetAuthorDetailsQuery({ slug });
  const { data: booksByAuthor } = useGetBooksByAuthorQuery(author?._id, {
    skip: !author?._id,
  });
  const { data: booksByTranslator } = useGetBooksByTranslatorQuery(author?._id, {
    skip: !author?._id,
  });
  if (isLoading) return <Loader />;
  if (error) return <Message variant='danger'>{error?.data?.message || error.error}</Message>;

  const socialLinks = [
    { url: author.wikipedia, icon: <FaWikipediaW className="logo-reseaux-sociaux" /> },
    { url: author.youtube, icon: <FaYoutube className="logo-reseaux-sociaux" /> },
    { url: author.facebook, icon: <FaFacebook className="logo-reseaux-sociaux" /> },
    { url: author.twitter, icon: <FaXTwitter className="logo-reseaux-sociaux" /> },
    { url: author.instagram, icon: <FaInstagram className="logo-reseaux-sociaux" /> },
    { url: author.linkedin, icon: <FaLinkedin className="logo-reseaux-sociaux" /> },
    // { url: author.bluesky, icon: <FaBluesky className="logo-reseaux-sociaux" /> },
    { url: author.threads, icon: <FaThreads className="logo-reseaux-sociaux" /> },
    { url: author.mastodon, icon: <FaMastodon className="logo-reseaux-sociaux" /> },
  ];

  return (
    <Container>
      <div className="author-profile">
        <div className="author-profile-img-container">
          <img src={author.photo} className="author-profile-img" alt={`${author.firstName} ${author.lastName}`} title={`${author.firstName} ${author.lastName}`} />
          <div className="author-links">
            {author.website && (
              <a href={`https://${author.website}`} target="_blank" rel="noopener noreferrer" className="authorWebsite">
                {author.website}
              </a>
            )}
            {socialLinks.map((social, index) =>
              social.url ? (
                <a key={index} href={social.url} target="_blank" rel="noopener noreferrer">
                  {social.icon}
                </a>
              ) : null
            )}
          </div>
        </div>
        
        <div className="h-container">
          <h1>{author.firstName} {author.lastName}</h1>
        </div>
        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(author.bio) }} />
        {(author.biblio || booksByAuthor?.length > 0) && <div className="h-container"><h2>Bibliographie</h2></div>}
        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(author.biblio) }} className="no-margin-paragraphs"/>
        {booksByAuthor?.length > 0 && (
          <div className="book-author-row">
            {booksByAuthor.map((book) => (
              <div className='book-card' key={book._id}>
                <BookCard book={book} showPanier={true} />
              </div>
            ))}
          </div>
        )}
        {( booksByTranslator?.length > 0) && <h2>Traduction{( booksByTranslator?.length > 1)&& 's'}</h2>}
        {booksByTranslator?.length > 0 && (
          <div className="book-author-row">
            {booksByTranslator.map((book) => (
              <div className='book-card' key={book._id}>
                <BookCard book={book} showPanier={true} />
              </div>
            ))}
          </div>
        )}
      </div>
    </Container>
  );
};

export default AuthorScreen;















// import { useParams } from 'react-router-dom';
// import {
//   Container
//   //, Row, Col, Image, ListGroup, Card, Button, Form,
// } from 'react-bootstrap';
// // import { toast } from 'react-toastify'; // resservira sûrement
// import {
//     useGetAuthorDetailsQuery,
// } from '../slices/authorsApiSlice';
// import Loader from '../components/Loader';
// import Message from '../components/Message';
// import AuthorProfile from '../components/AuthorProfile';

// const AuthorScreen = () => {
//   //const { id: authorId } = useParams();
//   const { slug } = useParams();
  
//   const {
//     data: author,
//     isLoading,
//     error,
//   } = useGetAuthorDetailsQuery({slug});



//   return (
//     <Container>
//       {isLoading ? (
//         <Loader />
//       ) : error ? (
//         <Message variant='danger'>
//           {error?.data?.message || error.error}
//         </Message>
//       ) : (
//         <>
//           <AuthorProfile author={author} />
//         </>
//       )}
//     </Container>
//   );
// };

// export default AuthorScreen;
